import { CanjeModalContextType } from '../types/CanjeModalContextType';

export const canjeModalInitValue: CanjeModalContextType = {
  data: {
    date: '',
    ratioOld: 0,
    ratioNew: 1,
    comments: '',
    file: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    scriptureView: true,
    lastOperationDate: '',
    isLoading: false,
    targetSocietyId: '',
    targetSocietyOption: null,
    targetSocietyOptions: [],
    isLoadingSocieties: false,
    selectedOriginHoldingClass: '',
    selectedOriginHoldingClassOption: null,
    originHoldingClassOptions: [],
    isLoadingOriginHoldingClasses: false,
    selectedHoldingClass: '',
    selectedHoldingClassOption: null,
    holdingClassOptions: [],
    previewParticipants: [],
    previewErrorKey: null,
    originShareClassName: '',
    isLoadingPreview: false,
    societyActualShares: 0,
    originCategoryOptions: [],
    targetCategoryOptions: [],
    isLoadingOriginCategories: false,
    isLoadingTargetCategories: false,
    originCategoryAllOption: null,
    originCategoryPeaksOption: null,
    targetCategoryAllOption: null,
    targetCategoryPeaksOption: null,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeRatioOld(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangeNotaryName(): void {},
    handleChangeNotaryProtocol(): void {},
    handleChangeNotaryCity(): void {},
    handleTargetSocietyChange(): void {},
    handleChangeOriginHoldingClass(): void {},
    async handleFetchOriginHoldingClassByTerm() {
      return undefined;
    },
    handleChangeHoldingClass(): void {},
    async handleFetchHoldingClassByTerm() {
      return undefined;
    },
    handleChangeOriginCategoryAll(): void {},
    handleChangeOriginCategoryPeaks(): void {},
    handleChangeTargetCategoryAll(): void {},
    handleChangeTargetCategoryPeaks(): void {},
    handleSaveCanje(): void {},
  },
};
